import React from 'react'
import { Link } from 'react-router-dom'
function MyBidMyPrice() {
  return (
    <>
            <div className="page-content pt-150 pb-150">
                <div className="container">
                    <div className="row">
                        <div className="col-xl-8 col-lg-10 col-md-12 m-auto text-center">
                            <h1 className="display-2 mb-30">We're launching soon!</h1>
                            <p className="font-lg text-grey-700 mb-30">
                                The page you're looking for isn't available yet, but we're working on it. Stay tuned!<br />
                                In the meantime, you can visit the <Link to="/"><span>Homepage</span></Link> or <Link to="/contact"><span>Contact us</span></Link> if you have any questions.
                            </p>
                            <Link className="btn btn-default submit-auto-width font-xs hover-up mt-30" to="/"><i className="fi-rs-home mr-5"></i> Back To Home Page</Link>
                        </div>
                    </div>
                </div>
            </div>
        </>
  )
}

export default MyBidMyPrice
